import FormService from "../../services/FormService";
import {ModelSelect} from 'vue-search-select';
import SelectPicker from '../../components/SelectPicker';
import FormInput from '../../components/FormInput';

export default {
    components: {ModelSelect, SelectPicker, FormInput},
    data() {
        return {
            form: new FormService({
                name: null,
                name_uz: null,
                name_en: null,
                number: null,
                routes_stations: [],
                comment: null,
                is_international: false
            }),
            id: null,
            allStations: [],
            stations: [],
            station: null,
            selected: {},
            name_access: [],
            names_array: [],
        }
    },
    created() {
        let id = this.$route.params.id;
        this.id = id;
        if (id) {
            this.getRoute();
        }
        this.$api.get('stations.all')
            .then(res => {
                res.data.forEach(item => {
                    this.allStations.push({
                        value: item.id,
                        text: item.name
                    })
                });
            })
    },
    methods: {
        getRoute() {
            this.$api.get('routes.show', this.id)
                .then(res => {
                    let data = res.data;
                    this.form.comment = data.comment;
                    this.form.name = data.name;
                    this.form.name_uz = data.name_uz;
                    this.form.name_en = data.name_en;
                    this.form.number = data.number;
                    this.form.is_international = data.is_international || false;
                    this.form.routes_stations = [];
                    data.stations.forEach(item => {
                        this.form.routes_stations.push({
                            station: {name: item.name},
                            station_id: item.pivot.station_id,
                            distance: item.pivot.distance,
                            order: item.pivot.order
                        })
                    });
                })
        },
        addStation() {
            let station = this.allStations.find(item => item.value === this.station);
            let exist = this.form.routes_stations.find(item => item.station_id === station.value);
            if (!exist) {
                this.form.routes_stations.push({
                    station: {
                        name: station.text
                    },
                    station_id: station.value,
                    order: this.form.routes_stations.length + 1,
                    distance: null
                });
                this.sortStations();
            } else {
                alert(this.i18n('This stop has already been added to the route.'));
                this.selectRow(exist);
            }
            this.generateName();
        },
        selectRow(station) {
            if (station.station_id === this.selected.station_id) {
                this.selected = {};
            } else {
                this.selected = station;
            }
        },
        sortStations() {
            this.form.routes_stations.sort((c, n) => {
                return c.order - n.order
            });
            this.form.routes_stations.forEach((item, key) => {
                item.order = key + 1;
            });
            this.generateName();
        },
        moveUp() {
            if (this.selected && this.selected.order > 1) {
                let prev = this.form.routes_stations.find(item => item.order === this.selected.order - 1);
                prev.order++;
                this.selected.order--;
            }
            this.sortStations();
        },
        moveDown() {
            if (this.selected && this.selected.order < this.form.routes_stations.length) {
                let next = this.form.routes_stations.find(item => item.order === this.selected.order + 1);
                next.order--;
                this.selected.order++;
            }
            this.sortStations();
        },
        addToNames(station = null) {
            if (station) {
                let exist = this.names_array.find(item => item.station_id === station.station_id);
                if (!exist) {
                    this.names_array.push(station);
                } else {
                    let indx = this.names_array.indexOf(station);
                    this.names_array.splice(indx, 1);
                }
            }
            this.generateName();
        },
        generateName() {
            let name = '';
            if (this.form.routes_stations.length >= 2) {
                let from = this.form.routes_stations[0].station.name;
                let to = this.form.routes_stations[this.form.routes_stations.length - 1].station.name;
                name = from + ' - ' + to;
            }
            if (this.names_array.length > 0) {
                name += ' ч/з ';
                this.names_array.forEach(item => {
                    name += item.station.name + ', ';
                })
            }
            this.form.name = name;
        },
        save(redirect = false) {
            if (this.id) {
                this.update(redirect);
            } else {
                this.create(redirect);
            }
        },
        create(redirect) {
            this.form.post('routes.create')
                .then(res => {
                    if (!res.errors) {
                        if (redirect) {
                            this.$router.push('/routes');
                        } else {
                            this.$router.push('/routes/update/' + res.data.id);
                        }
                        this.$store.commit('successNotify')();
                    }
                })
        },
        update(redirect) {
            this.form.put('routes.update', this.id)
                .then(res => {
                    if (!res.errors) {
                        if (redirect) {
                            this.$router.push('/routes');
                        } else {
                            this.$router.push('/routes/update/' + res.data.id);
                        }
                        this.$store.commit('successNotify')();
                    }
                })
        },
        removeStation(item) {
            this.form.routes_stations.splice(this.form.routes_stations.indexOf(item), 1);
            this.sortStations();
            this.generateName();
        },
    },
    beforeRouteUpdate(to, from, next) {
        let id = to.params.id;
        if (id) {
            this.id = id;
            this.getRoute();
        }
        next();
    }
}
